export default __webpack_public_path__ + "static/media/Glacier-Caves.806719c7.jpg";